import moment from 'moment';
import ListType from './converters/ListType';
import DTO from './DTO';
import {
  email,
  maxLength50,
  minLength3,
  trimError, onlyLettersAndHyphen,
} from '../utils/validation';

class UserDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'user.id',
      },
      {
        name: 'token',
        type: String,
        validators: {},
        labelKey: 'user.token',
      },
      {
        name: 'username',
        type: String,
        validators: { maxLength50 },
        labelKey: 'username',
      },
      {
        name: 'full_name',
        type: String,
        labelKey: 'user.full_name',
      },
      {
        name: 'password',
        type: String,
        validators: { maxLength50 },
        labelKey: 'password',
      },
      {
        name: 'password_confirmation',
        type: String,
        // validators: {required, maxLength255, minLength5},
        validators: { maxLength50 },
        labelKey: 'password_confirmation',
      },
      {
        name: 'role',
        type: Number,
        validators: {},
        labelKey: 'user.role',
      },
      {
        name: 'statuses',
        type: String,
        validators: {},
        labelKey: 'user.statuses',
      },
      {
        name: 'is_active',
        type: Boolean,
        validators: {},
        labelKey: 'user.is_active',
      },
      {
        name: 'tg_id',
        type: String,
        validators: {},
        labelKey: 'user.tg_id',
      },
      {
        name: 'tg_username',
        type: String,
        validators: {},
        labelKey: 'user.tg_username',
      },
      {
        name: 'created_at',
        type: moment,
        validators: {},
        labelKey: 'created_at',
      },
      {
        name: 'updated_at',
        type: moment,
        validators: {},
        labelKey: 'user.updatedAt',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getRegistrationData() {
    return {
      email: this.email,
      password: this.password,
    };
  }

  getData() {
    const data = {
      email: this.email,
      name: this.name,
      role_ids: this.role_ids,
      is_active: this.is_active,
      settings: {
        locale: this.locale,
      },
    };
    if (this.password) {
      data.password = this.password;
      data.password_confirmation = this.password;
    }
    return data;
  }

  getLoginData() {
    return {
      username: this.username,
      password: this.password,
    };
  }

  getForgotData() {
    return {
      email: this.email,
    };
  }

  getCreateData() {
    return {
      username: this.username,
      full_name: this.full_name,
      password: this.password,
      role: this.role,
    };
  }
}

export default UserDTO;
